import styled from "styled-components";

export const PersonalInformationParent = styled.section`
  width: 70%;
  height: 100%;
`;

export const PersonalInfoWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 3rem;
`;

export const Heading = styled.h3`
  font-weight: 500;
  font-size: 2rem;
  line-height: 3.4rem;
  color: #1e1e1e;
`;

export const ResumeForm = styled.form`
  width: 100%;
  height: 60%;
  margin-top: 1rem;
`;

export const DivideWrapper = styled.div`
  display: flex;
  width: 75%;
  gap: 2rem;
  margin-top: 1rem;
`;

export const Side = styled.div`
  width: 50%;
`;

export const NavigateButton = styled.button`
  margin-top: 1rem;
  background: #0570fb;
  border-radius: 4px;
  padding: 12px 32px;
  width: 25.7rem;
  height: 4.8rem;
  color: #fff;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 24px;
`;
